import api from "./api";

export const getMyBankAccount = async () => {
  return api
    .get({
      endpoint: "/bank-account",
      port: process.env.REACT_APP_PORT_VENUE,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
